import { ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged, filter, map, startWith, takeUntil, tap } from 'rxjs/operators';
import { Item } from 'src/app/components/shared/models/item';
import { checkValueInList } from './control-utils';
import { onError } from './global-error-handler';
import { loading } from './loading';
import { ItemEstrutura } from './item-estrutura';

export interface EstruturaComponent {
    select: NgControl;
    element: ElementRef<HTMLElement>;
    readonly: boolean;
}

export function toItem(comp: EstruturaComponent): (source: Observable<ItemEstrutura[]>) => Observable<Item[]> {
    return (source: Observable<ItemEstrutura[]>) => {
        return source.pipe(
            loading(comp.element),
            onError([]),
            tap(itens => itens?.sort((a, b) => a.descricao.localeCompare(b.descricao))),
            map(itens => itens?.map(item => new Item(item.id, itemGetLabel(item)))),
            tap(itens => checkValueInList(comp.select.control, itens)),
            startWith([])
        );
    };
}

export function toItemSemCodigo(comp: EstruturaComponent): (source: Observable<ItemEstrutura[]>) => Observable<Item[]> {
    return (source: Observable<ItemEstrutura[]>) => {
        return source.pipe(
            loading(comp.element),
            onError([]),
            tap(itens => itens?.sort((a, b) => a.descricao.localeCompare(b.descricao))),
            map(itens => itens?.map(item => new Item(item.id, item.descricao))),
            tap(itens => checkValueInList(comp.select.control, itens)),
            startWith([])
        );
    };
}

/**
 * Define o select como readonly e seta o valor fixo se necessário.
 * @param comp Componente que contém o select de órgão, upag ou uorg.
 * @param value$ Observable que vai fornecer o valor fixo do campo. Quando resolver para null ou 0 o campo permite edição.
 */
export function setReadonlyValue(comp: EstruturaComponent, value$: Observable<number>) {
    // este subject serve para remover o subscribe de valueChanges sempre que chegar um novo valor em value$
    const newValue$ = new Subject<number>();
    const origReadonly = comp.readonly;
    value$
        .pipe(distinctUntilChanged())
        .subscribe(value => {
            newValue$.next(value);
            if (!value) {
                comp.readonly = origReadonly;
                return;
            }
            comp.readonly = true;
            comp.select.reset(value);
            //fixValue(comp.select, value, newValue$);
        })
        .add(newValue$);
}

function fixValue(select: NgControl, value: number, newValue$: Observable<number>) {
    select.reset(value);
    // para o caso do valor ser alterado via url ou via "Limpar"
    select.valueChanges
        .pipe(
            takeUntil(newValue$),
            distinctUntilChanged(),
            filter(newValue => newValue != value)
        )
        .subscribe(() => select.reset(value));
}

export function itemGetLabel(item: ItemEstrutura): string {
    return (item.id + '').padStart(5, '0') + (item.sigla && item.sigla.trim().length > 0 ? ' - ' + item.sigla : '') + ' - ' + item.descricao;
}
